import Bowser from 'bowser-ultralight';
import memoizeOne from 'memoize-one';
import { getWindowObject } from '../utils/window-helper';
export var eventBrowserPlugin = memoizeOne(function () {
  var _getWindowObject;
  if (!Bowser.getParser) {
    return null;
  }
  var browser = Bowser.getParser(((_getWindowObject = getWindowObject()) === null || _getWindowObject === void 0 || (_getWindowObject = _getWindowObject.navigator) === null || _getWindowObject === void 0 ? void 0 : _getWindowObject.userAgent) || '');
  return {
    'event:browser:name': browser.getBrowserName(),
    'event:browser:version': browser.getBrowserVersion()
  };
});